class CustomAccordion extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const accordionItems = this.querySelectorAll('.accordion-item');

        const handleAccordionClick = (event) => {
            const currentItem = event.currentTarget.parentNode;
            const accordionContent = currentItem.querySelector('.accordion-content');
            const contentHeight = accordionContent.scrollHeight;

            // Закрыть все открытые элементы, кроме текущего
            accordionItems.forEach((item) => {
                if (item !== currentItem && item.classList.contains('open')) {
                    item.classList.remove('open');
                    item.querySelector('.accordion-content').style.maxHeight = null;
                }
            });

            // Открыть или закрыть текущий элемент
            if (currentItem.classList.contains('open')) {
                currentItem.classList.remove('open');
                accordionContent.style.maxHeight = null;
            } else {
                currentItem.classList.add('open');
                accordionContent.style.maxHeight = `${contentHeight + 15}px`;
            }
        };

        if (accordionItems) {
            accordionItems.forEach((item) => {
                const accordionHeader = item.querySelector('.accordion-header');
                accordionHeader.addEventListener('click', handleAccordionClick);

                // Установить начальную высоту для открытых элементов
                if (item.classList.contains('open')) {
                    const accordionContent = item.querySelector('.accordion-content');
                    const contentHeight = accordionContent.scrollHeight;
                    accordionContent.style.maxHeight = `${contentHeight + 15}px`;
                }
            });
        }
    }
}

customElements.define('custom-accordion', CustomAccordion);
